

import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
// import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
// EXCEL SHEET
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// EXCEL SHEET

//  CODE FOR ONE PAGE
import LayerPanelPage from "./LayerPanelPage";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import "@arcgis/core/assets/esri/themes/light/main.css";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import html2pdf from "html2pdf.js";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";
//Graphic show on map

import Graphic from "@arcgis/core/Graphic";


import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import { set } from 'lodash';

import "./ScadaCSS.css";
import "./SCADAHOMECSS.css";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from 'bootstrap';
import ScadaChart from "./SCADALive.js";

// import { fontFamily } from 'html2canvas/dist/types/css/property-descriptors/font-family';


// Layer definitions
const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const layers = {
  WATER_Distribution_Network: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/ws_intersect_poi/MapServer",
    sublayerId: 1
  },

};

const layersSpc = {
  SEWER_Line: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/scada_device_location/MapServer",
    sublayerId: 1
  },

};


//  layer End 


function SCADALive({ isWidth, isScreenSize, isByDefaultActive }) {
  // CODE FOR TABLE LOCAL
  const [LiveData, setLiveData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [stationFilter, setStationFilter] = useState("");
  // CODE FOR TABLE LOCAL


  // const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  const [tabLocation, setTabLocation] = useState(false);
  const { isTheme, isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const dispatch = useDispatch()
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const authData = useSelector(state => state.authToken.authData);

  const [ulbs, setUlbs] = useState([]);
  const [selectedUlb, setSelectedUlb] = useState("");
  const [ulbCode, setUlbCode] = useState("");



  //   NEW TOOLS 2025
  // 30 DEC 2025 
  const layerRef = useRef(null);
  const [map, setMap] = useState(null);
  const mapDiv = useRef(null);

  // TABLE DATA
  const [totalCount, setTotalCount] = useState(0);

  const [tableData, setTableData] = React.useState([]);
  const [distictList, setdistictList] = React.useState([]);


  const [openDiv, setOpenDiv] = useState("div1");

  const [loading, setLoading] = React.useState(false);


  //  DATA
  //  NEW STATE 


  const buildFilter = (dist_cd, ulb_cd, wardno) => {
    const conditions = [];
    if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
    if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
    if (wardno) conditions.push(`wardno = '${wardno}'`);
    return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
  };


  const [view, setView] = useState(null);

  useEffect(() => {

    if (!mapDiv.current) return;
    const mapInstance = new Map({
      basemap: "topo-vector"  // Use your desired basemap
    });

    const mapView = new MapView({
      container: mapDiv.current,  // The div where the map will render
      map: mapInstance,
      center: [77.4126, 23.2599],
      zoom: 5,
      ui: { components: ["attribution"] }
    });

    // Optionally, add a default layer
    const baseLayer = new MapImageLayer({
      url: mainLayerUrl,
      sublayers: []  // No initial sublayers
    });
    mapInstance.add(baseLayer);
    layerRef.current = baseLayer;

    setMap(mapInstance);    // Set the map reference
    setView(mapView);
    //  AdminLayer(0);    // Set the view reference


    // MAP LAYER LIST  Widget 

    mapView.ui.add(new Home({ view: mapView }), "top-left");
    mapView.ui.add(new Zoom({ view: mapView }), "top-left");
    mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
    mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");
    mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");

    mapView.when(() => {
      const printWidget = new Print({
        view: mapView,
        printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
      });

      const expandPrint = new Expand({
        view: mapView,
        content: printWidget
      });

      mapView.ui.add(expandPrint, "top-left");

    });

    return () => mapView.destroy();


    // end useEffect
  }, []);

  // end useEffect
  // CODE FOR CSS 3FEB 






  // CODE FOR CSS  3FEB

  useEffect(() => {

    fetchScadaData(null, null, null);
    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // CODE FOR  TABLE LiveDATA API CALL



  // const fetchScadaData = async (districtCode, ulbCode, siteId) => {
  //   try {

  //     const response = await fetch(
  //       "https://urbangis.mp.gov.in/api/Station_Data/GetScadaDataSitewise",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ distCd: districtCode, ulbCd: ulbCode, siteId: siteId }),
  //       }
  //     );
  //     if (!response.ok) throw new Error("Failed to fetch data");
  //     const res = await response.json();

  //     const data = res.data || res || [];
  //     setLiveData(data);
  //     setFilteredData(data);


  //   } catch (error) {
  //     console.error("Error fetching SCADA data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // CODE FOR  TABLE LiveDATA API CALL
  const [noData, setNoData] = useState(false);
  const fetchScadaData = async (districtCode, ulbCode, siteId) => {
    try {
      setLoading(true);

      const response = await fetch(
        "https://urbangis.mp.gov.in/api/Station_Data/GetScadaDataSitewise",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            distCd: districtCode,
            ulbCd: ulbCode,
            siteId: siteId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const res = await response.json();

      // ✅ Handle No Data Found case
      if (res.statusCode === 404 || !res.data) {
        // console.warn(res.message || "No Data Found");


        // setLiveData(data && data.length > 0 ? data : []);
        // setFilteredData(Array.isArray(data) ? data : []);
        setNoData(true);
        //  setNoData(true);
        //  setLiveData([]);          // clear table
        // clear filtered data if used
        return;
      }

      // ✅ If data exists
      if (res.statusCode === 200 && Array.isArray(res.data)) {
        setLiveData(res.data);
        setFilteredData(data);
        setNoData(false);

      } else {
        // fallback if API returns different structure
        const data = res.data || [];
        setLiveData(data);

      }

    } catch (error) {
      console.error("Error fetching SCADA data:", error);
      setLiveData([]);

    } finally {
      setLoading(false);
    }
  };
  // CODE FOR TODAY DATE 

  const [ulbList, setUlbList] = useState([]);
  const fetchAllUlbs = async () => {
    try {
      const response = await fetch(
        "https://urbangis.mp.gov.in/api/Station_Data/GetScadaDataSitewise",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            distCd: null,
            ulbCd: null,
            siteId: null,
          }),
        }
      );

      const res = await response.json();
      console.log("API RESPONSE:", res);

      const data = res.data || [];

      // ✅ Extract unique ULBs
      const uniqueUlbs = [
        ...new Map(
          data.map((item) => [item.ulbCd, item.ulB_Name])
        ).entries(),
      ].map(([ulbCd, ulB_Name]) => ({
        ulbCd,
        ulB_Name,
      }));

      console.log("ULB LIST:", uniqueUlbs);

      // ✅ Set dropdown list
      setUlbList(uniqueUlbs);

    } catch (error) {
      console.error("Error fetching ULBs:", error);
    }
  };


  useEffect(() => {
    fetchAllUlbs();
  }, []);


  // After fetching and setting LiveData


  const counts = LiveData.reduce(
    (acc, item) => {
      if (["STP_OUTLET", "STP_INLET"].includes(item.stationName)) {
        const isOffline = item.cod == null && item.bod == null && item.ph == null;
        if (isOffline) acc.Offline += 1;
        else acc.Online += 1;
      }
      return acc;
    },
    { Online: 0, Offline: 0 }
  );

  // CODE FOR COUNT OFFLINE AND ONLINE STP


  const isLive = (item) => {
    return !(
      (["STP_OUTLET", "STP_INLET"].includes(item.stationName) &&
        item.cod == null &&
        item.bod == null &&
        item.ph == null) ||
      !isToday(item.recordDateTime)
    );
  };

  useEffect(() => {
    let temp = [...LiveData];

    // Status filter
    if (statusFilter) {
      temp = temp.filter(item =>
        statusFilter === "Live" ? isLive(item) : !isLive(item)
      );
    }

    // Station filter
    if (stationFilter) {
      temp = temp.filter(item => item.stationName === stationFilter);
    }

    setFilteredData(temp);
  }, [statusFilter, stationFilter, LiveData]);

  // CODE FOR TABLE DATA API CALL



 // CODE FOR TABLE DATA API CALL

const downloadPDF = () => {
  // Map the data to a simple array of objects for Excel
  const excelData = filteredData.map((item, index) => ({
    "S.No": index + 1,
    "ULB Name": item.ulB_Name,
    "Site ID": item.siteId,
    "Device Name": item.deviceName,
    "Station": item.stationName,
    "BOD (mg/L)": item.bod,
    "COD (mg/L)": item.cod,
    "TSS (mg/L)": item.tss,
    "pH": item.ph,
    "Flow (m³/h)": item.flow,
    "Total Flow (m³)": item.flow_Total,
    "Status": (["STP_OUTLET", "STP_INLET"].includes(item.stationName) &&
      (item.cod == null && item.bod == null && item.ph == null)) || !isToday(item.recordDateTime)
      ? "Offline"
      : "Live",
    "Last data received": item.recordDateTime?.replace("T", " ")
  }));

  // Create a worksheet
  const ws = XLSX.utils.json_to_sheet(excelData, { header: [
    "S.No",
    "ULB Name",
    "Site ID",
    "Device Name",
    "Station",
    "BOD (mg/L)",
    "COD (mg/L)",
    "TSS (mg/L)",
    "pH",
    "Flow (m³/h)",
    "Total Flow (m³)",
    "Status",
    "Last data received"
  ]});

  // Apply basic styles (like bold headers)
  const wscols = [
    { wch: 6 }, { wch: 20 }, { wch: 10 }, { wch: 20 }, { wch: 15 },
    { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 6 }, { wch: 12 },
    { wch: 12 }, { wch: 10 }, { wch: 20 }
  ];
  ws['!cols'] = wscols;

  // Create a workbook and append worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "SCADA Data");
  // Save Excel file
  XLSX.writeFile(wb, `SCADA_Report_${new Date().toISOString().slice(0,10)}.xlsx`);
};

  // QUERY SUBMIT
const pdfContainerStyle = {
  width: "100%",
  height: "600px",   // or any fixed height you want
  background: "#ffffff",
  padding: "15px",
  overflow: "auto",  // enables scrolling
};

  const navigate = useNavigate();
  const handleBackToClick = (row) => {
    // alert(`BACK TO SCADA`);
    navigate("/dashboard?type=13");
    //navigate("/dashboard?type=15");
  };


  const RPT_DateToClick = (row) => {
    // alert(`BACK TO SCADA`);
    navigate("/SCADAOffline");
    //navigate("/dashboard?type=15");
  };
  // CODE FOR TODAY DATE 
  const isToday = (date) => {
    const d = new Date(date);
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  };


  // COUNT ON FILTER 


  const summary = useMemo(() => {
    let Online = 0;
    let Offline = 0;

    // To count unique SCADA (site-wise)
    const uniqueSiteIds = new Set();

    filteredData.forEach(item => {
      uniqueSiteIds.add(item.siteId);

      const isLive =
        !(
          (["STP_OUTLET", "STP_INLET"].includes(item.stationName) &&
            item.cod == null &&
            item.bod == null &&
            item.ph == null) ||
          !isToday(item.recordDateTime)
        );

      if (isLive) {
        Online++;
      } else {
        Offline++;
      }
    });

    return {
      totalScadaInstalled: uniqueSiteIds.size,        // 👈 SCADA count
      totalDevices: filteredData.length,              // INLET + OUTLET
      Online,
      Offline,
    };
  }, [filteredData]);

  // COUNT ON FILTER
  const totalDeviceCount = [
    ...new Set(filteredData.map(item => item.deviceId))
  ].length;
  const isOffline = (item) =>
    (["STP_OUTLET", "STP_INLET"].includes(item.stationName) &&
      item.cod == null &&
      item.bod == null &&
      item.ph == null) ||
    !isToday(item.recordDateTime);

  const liveCount = filteredData.filter(
    (item) => !isOffline(item)
  ).length;

  const offlineCount = filteredData.filter(
    (item) => isOffline(item)
  ).length;

  const inletCount = filteredData.filter(
    (item) => item.stationName === "STP_INLET"
  ).length;

  const outletCount = filteredData.filter(
    (item) => item.stationName === "STP_OUTLET"
  ).length;

  const boxStyle = {
    padding: "10px 6px",
    borderRadius: "12px",
    background: "linear-gradient(145deg, #0d1b2a, #1b263b)",
    color: "#fff",
    minWidth: "100px",
    textAlign: "center",
    fontFamily: "'Inter', sans-serif",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.35)",

  };

  // COUNT ON FILTER

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
  };

  const thStyle = {
    backgroundColor: "#0d1b2a",
    color: "#fff",
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
  };

  const firstColumnStyle = {
    ...thStyle,
    position: "sticky",
    left: 0,        // stick first column
    zIndex: 3,      // above body cells
  };

  const tdStyle = {
    padding: "6px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const firstColumnTdStyle = {
    ...tdStyle,
    position: "sticky",
    left: 0,       // stick first column
    backgroundColor: "#f9f9f9",
    zIndex: 2,     // below header
  };
  const [hover, setHover] = useState(false);
  const customSelectStyle = {
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    backgroundColor: "#1b263b",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
    minWidth: "150px",
    marginRight: "10px",
    transition: "all 0.2s ease",
  };



  // BHUPEN_D
  useEffect(() => {
    const loadDistricts = async () => {
      const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson`;

      //alert(url);
      try {
        const response = await fetch(url);
        const data = await response.json();

        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
          const userDistrict = [{
            districtName: authData.DistrictName,
            districtCode: authData.DistrictCode,
          }];
          setDistricts(userDistrict);
          setDistrictCode(authData.DistrictCode);
          setSelectedDistrict(authData.DistrictName);
          await loadUlbs(authData.DistrictCode);
        } else {
          const formatted = data.features.map(f => ({
            districtName: f.properties.districtname,
            districtCode: f.properties.dist_cd,
          }));
          setDistricts(formatted);
        }
      } catch (err) {
        console.error("Error loading districts:", err);
      }
    };

    if (!view) return;

    loadDistricts();
  }, [selectedDistrict, selectedUlb, districtCode, ulbCode, authData, view]);

  const handleDistrictChange = async (selectedOption) => {
    if (!selectedOption) {
      handleRefresh();
      return;
    }
    const district = districts.find(d => d.districtCode === selectedOption.value);
    if (district) {
      setDistrictCode(district.districtCode);
      setSelectedDistrict(district.districtName);
      setUlbCode(""); setSelectedUlb("");
      // setWardCode(""); setSelectedWard("");
      //BHUPEN_ULB
      await loadUlbs(district.districtCode);
      fetchScadaData(district.districtCode, null, null);

    }
  };
  // BHUPEN_D
  // BHUPEN_ULB
  const loadUlbs = async (dist_cd) => {
    const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/94/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=ulbname,ulb_cd&returnDistinctValues=true&f=geojson`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      // 🔹 If logged-in user is normal User → auto ULB
      if (authData?.UserType === "User") {
        const formattedUlbs = [{
          ulbName: authData?.UlbName,
          ulbCode: authData?.Ulb_Code,
        }];

        setUlbs(formattedUlbs);

        // auto select
        setUlbCode(authData?.Ulb_Code);
        setSelectedUlb(authData?.UlbName);

        // await loadWards(authData?.Ulb_Code);
        //zoomToFeatureTow(authData?.UlbName, "name", "5");
      }
      // 🔹 District / Admin users
      else if (data?.features) {
        const formattedUlbs = data.features.map(f => ({
          ulbName: f.properties.ulbname,
          ulbCode: f.properties.ulb_cd,
        }));

        setUlbs(formattedUlbs);
      }

    } catch (error) {
      console.error("Error fetching ULBs:", error);
    }
  };
  const handleUlbChange = async (selectedOption) => {
    if (!selectedOption) {
      setUlbCode(""); setSelectedUlb("");
      return;
    }
    const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
    if (ulb) {
      setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName);
      fetchScadaData(null, ulb.ulbCode, null);

    }
  };

  // BHUPEN_R CODE 
  const handleRefresh = async () => {
    // Reset Map
    view.graphics.removeAll(); // Clear any highlights

    // Go to the initial extent or center
    view.goTo({
      center: [77.4126, 23.2599],
      zoom: 6,
      ui: { components: ["attribution"] }
    });

    // Reset all filter states
    setSelectedDistrict("");
    setDistrictCode("");
    // setSelectedUlb("");
    // setUlbCode("");
    // setSelectedWard("");
    // setWardCode("");
    // setTableData("");
    //setTableData2("");

    // Reset dropdown options
    // setUlbs([]);
    // setWards([]);

    // // Dispatch reset actions
    // dispatch(setIsDist(""));
    // dispatch(setIsUlb(""));
    // dispatch(setIsWard(""));
    // Reset the map view to initial state

  };
  // CODE FOR TODSY DATE 
  // BHUPEN CODE FOR SORTING 
  const sortedData = useMemo(() => {
  const stationOrder = {
    STP_INLET : 1,
    STP_OUTLET: 2
  
  };

  return [...filteredData].sort((a, b) => {
    if (a.siteId !== b.siteId) {
      return Number(a.siteId) - Number(b.siteId);
    }

    return (stationOrder[a.stationName] || 99) -
           (stationOrder[b.stationName] || 99);
  });

}, [filteredData]);
// BHUPEN CODE FOR SORTING 
  return (
    <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 605px)' }} className='px-2'>

      <style>
        {`
          @media print {
          table, td, th {
          -webkit-print-color-adjust: exact !important;
           }
        }
        `}
      </style>
      <div>


        {!loading && LiveData.length > 0 && (
          <>
            <div style={{ padding: "10px", textAlign: "center", }}>
              <center> <table>
                <tr>
                  <td colSpan={14} style={{
                    padding: "10px", background:
                      "linear-gradient(90deg, #0f9239, #2658b6)",
                  }}>
                    <div
                      style={{
                        display: "flex",

                        alignItems: "center",
                        gap: "12px", // spacing between dropdowns and button
                        flexWrap: "wrap", // wrap on small screens
                      }}
                    >
                      <select
                        style={{
                          ...customSelectStyle,
                          borderColor: hover ? "#00b4d8" : "#ccc",
                        }}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        value={districtCode || ""}
                        onChange={(e) =>
                          e.target.value === ""
                            ? handleRefresh()
                            : handleDistrictChange({
                              value: e.target.value,
                              label: e.target.options[e.target.selectedIndex].text,
                            })
                        }
                        disabled={
                          authData?.UserType === "districtuser" ||
                          authData?.UserType === "User"
                        }
                        className="mt-3"
                      >
                        <option value="">Select District</option>

                        {districts
                          .map((d) => ({
                            value: d.districtCode,
                            label: d.districtName,
                          }))
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((district) => (
                            <option key={district.value} value={district.value}>
                              {district.label}
                            </option>
                          ))}
                      </select>


                      <select
                        style={{
                          ...customSelectStyle,
                          borderColor: hover ? "#00b4d8" : "#ccc",
                        }}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        value={ulbCode || ""}
                        onChange={(e) =>
                          e.target.value === ""
                            ? handleUlbChange(null)
                            : handleUlbChange({
                              value: e.target.value,
                              label: e.target.options[e.target.selectedIndex].text,
                            })
                        }
                        disabled={
                          authData?.UserType === "districtuser" ||
                          authData?.UserType === "User" ||
                          !districtCode
                        }
                        className="mt-3"
                      >
                        <option value="">Select ULB</option>

                        {ulbs
                          .map((u) => ({
                            value: u.ulbCode,
                            label: u.ulbName,
                          }))
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((ulb) => (
                            <option key={ulb.value} value={ulb.value}>
                              {ulb.label}
                            </option>
                          ))}
                      </select>

                      {/* Status Filter */}
                      <select
                        style={{
                          ...customSelectStyle,
                          borderColor: hover ? "#00b4d8" : "#ccc",
                        }}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="" style={{ backgroundColor: "#1b263b", color: "#fff" }}>
                          All Status
                        </option>
                        <option value="Live" style={{ backgroundColor: "#1b263b", color: "#fff" }}>
                          Live
                        </option>
                        <option value="Offline" style={{ backgroundColor: "#1b263b", color: "#fff" }}>
                          Offline
                        </option>
                      </select>

                      {/* Station Filter */}
                      <select
                        style={{
                          ...customSelectStyle,
                          borderColor: hover ? "#00b4d8" : "#ccc",
                        }}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onChange={(e) => setStationFilter(e.target.value)}
                      >
                        <option value="" style={{ backgroundColor: "#1b263b", color: "#fff" }}>
                          All Stations
                        </option>
                        <option value="STP_INLET" style={{ backgroundColor: "#1b263b", color: "#fff" }}>
                          STP_INLET
                        </option>
                        <option value="STP_OUTLET" style={{ backgroundColor: "#1b263b", color: "#fff" }}>
                          STP_OUTLET
                        </option>
                      </select>

                      {/* Refresh Button */}
                      <button
                        style={{
                          borderRadius: "4px",
                          padding: "6px 12px",
                          border: "1px solid #ccc",
                          backgroundColor: "#1b263b",
                          color: "#fff",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                        onClick={() => window.location.reload()}
                      >
                        <span style={{ display: "inline-block" }}>🔄</span>
                        Refresh
                      </button>
                    </div>
                  </td>
                </tr>

              </table>
              </center>
              <div style={{ marginBottom: "10px", }}>

                <button style={{
                  float: "right", borderRadius: "4px", overflow: "auto",
                }} onClick={handleBackToClick}>Back </button>
          <button style={{
                  float: "right", borderRadius: "4px", overflow: "auto",
                }} onClick={downloadPDF}>Download </button>

          <button style={{
                  float: "right", borderRadius: "4px", overflow: "auto",
                }} onClick={RPT_DateToClick}> Date wise Reports  </button>

              </div>
            </div>           
            <center>
              {noData && (
                <table>
                  <tbody>
                    <tr>
                      <td
                        colSpan={14}
                        style={{
                          textAlign: "center",
                          color: "red",
                          padding: "15px",
                          fontWeight: "bold"
                        }}
                      >
                        No Data Found
                        {selectedUlb
                          ? ` in selected ULB ------- ${selectedUlb}`
                          : selectedDistrict
                            ? ` in selected District ------  ${selectedDistrict}`
                            : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </center>

            <div id="pdfTable" >
              {LiveData && LiveData.length > 0 ? (
                <div>
                  <div
                    style={{ borderRadius:"4px",
                      background: "linear-gradient(90deg, #c6c923, #8eccca)",
                      padding: "2px",
                      textAlign: "center",
                    }} >
                    <b> Supervisory Control And Data Acquisition</b>
                    <br />
                    <div style={{ textAlign: "center", display: "flex", gap: "15px", margin: "10px 0" }}>

                      <div style={{ ...boxStyle, color: "#b7dbd7" }}>
                        Total  Records : {totalDeviceCount}
                      </div>
                      <div style={{ ...boxStyle, color: "#3498db" }}>INLET: {inletCount}</div>
                      <div style={{ ...boxStyle, color: "#f39c12" }}>OUTLET: {outletCount}</div>
                      <div style={{ ...boxStyle, color: "#2ecc71" }}>Live: {liveCount}</div>
                      <div style={{ ...boxStyle, color: "red" }}>Offline: {offlineCount}</div>
                    </div>
                  </div>


                  <div style={pdfContainerStyle}>
                     <b>
                              Last data received: 10 minutes
                            </b>
                    <table style={tableStyle}>
                      <thead>
                        <tr>
                          <th style={firstColumnStyle}>S.No</th>
                          <th style={thStyle}>ULB Name</th>
                          <th style={thStyle}>Site ID</th>
                          <th style={thStyle}>Device Name</th>
                          <th style={thStyle}>Station</th>
                          <th style={thStyle}>BOD (mg/L)</th>
                          <th style={thStyle}>COD (mg/L)</th>
                          <th style={thStyle}>TSS (mg/L)</th>
                          <th style={thStyle}>pH</th>
                          <th style={thStyle}>Flow (m³/h)</th>
                          <th style={thStyle}>TotalFlow (m³)</th>
                          <th style={thStyle}>Status</th>
                          <th style={thStyle}>Last data received</th>
                        </tr>
                      </thead>

                      <tbody>
                      {sortedData.map((item, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor: item.siteId % 2 === 0 ? "#0d1b2a" : "#222a33",
                              color: "#ffffff",
                            }}
                          >
                            <td style={thStyle}>{index + 1}</td>
                            <td style={thStyle}>{item.ulB_Name}</td>
                            {/* <td style={tdStyleTD}>{item.deviceId}</td>
                                <td style={tdStyleTD}>{item.siteId}</td> */}
                            <td style={thStyle}>{item.siteId}</td>
                            <td style={thStyle}>{item.deviceName}</td>
                            <td style={thStyle}>{item.stationName}</td>
                            {/* BOD */}

                            <td
                              style={thStyle}
                              className={
                                item.stationName === "STP_OUTLET" && item.bod > 10
                                  ? "blink-danger-text"
                                  : "blink-danger-text_Narmal"
                              }
                            >
                              {item.bod}
                            </td>
                            {/* <td style={tdStyleTD}>{item.bod}</td> */}

                            <td style={thStyle}
                              className={item.stationName === "STP_OUTLET" && item.cod > 50
                                ? "blink-danger-text"
                                : "blink-danger-text_Narmal"} >
                              {item.cod}
                            </td>

                            {/* <td style={tdStyleTD}>{item.tss}</td> */}
                            <td style={thStyle}
                              className={item.stationName === "STP_OUTLET" && item.tss > 10
                                ? "blink-danger-text"
                                : "blink-danger-text_Narmal"} >
                              {item.tss}
                            </td>
                            {/* <td style={tdStyleTD}>{item.ph}</td> */}
                            <td style={thStyle}
                              className={item.stationName === "STP_OUTLET" && item.ph > 9
                                ? "blink-danger-text"
                                : "blink-danger-text_Narmal"} >
                              {item.ph}
                            </td>
                            <td style={thStyle}>{item.flow}</td>
                            <td style={thStyle}>{item.flow_Total}</td>
                            {/* <td style={tdStyleTD}>  
                                                                                 <span style={badgeStyle}>Live</span>
                                                                             </td> */}
                            <td
                              style={{
                                ...thStyle,
                                fontWeight: "bold",
                                color:
                                  (["STP_OUTLET", "STP_INLET"].includes(item.stationName) &&
                                    item.cod == null &&
                                    item.bod == null &&
                                    item.ph == null) ||
                                    !isToday(item.recordDateTime)
                                    ? "red"
                                    : "#2ecc71",

                              }}
                            >
                              {(["STP_OUTLET", "STP_INLET"].includes(item.stationName) &&
                                item.cod == null &&
                                item.bod == null &&
                                item.ph == null) ||
                                !isToday(item.recordDateTime)
                                ? "Offline"
                                : "Live"}
                            </td>


                            <td style={thStyle}>
                              <center>{item.recordDateTime?.replace("T", " ")}</center>
                            </td>
                           
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div style={{ padding: "10px", textAlign: "center" }}>

                </div>
              )}

            </div>
          </>
        )}
      </div>
      <div ref={mapDiv}
        style={{
          width: "100%",
          height: '0px',
          overflow: "hidden",

        }}
      >
      </div>
    </div>
  )
}
export default SCADALive



